import Modal from "common/Modal/Modal.tsx";
import Button from "common/Buttons/Button.tsx";
import CreateOrEditPayoutMethodForm from "features/payouts/PayoutMethods/CreateOrEditPayoutMethodForm.tsx";
import useCreatePayoutMethod from "features/affiliation/common/hooks/useCreatePayoutMethod.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";

import {
  LanguageNameSpaces,
  PayoutMethod,
  PayoutMethodSource,
} from "@shared/types";

interface CreatePayoutMethodModalProps {
  isVisible: boolean;
  closeModal: () => void;
  source: PayoutMethodSource;
  isEdit?: boolean;
  payoutMethod?: PayoutMethod;
}

const CreateOrEditPayoutMethodModal = ({
  isVisible,
  closeModal,
  source,
  isEdit,
  payoutMethod,
}: CreatePayoutMethodModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.PAYOUTS);
  const {
    createLoading,
    editLoading,
    createPayoutMethodHandler,
    asset,
    setAsset,
    network,
    setNetwork,
  } = useCreatePayoutMethod({
    closeModal,
    source,
    isEdit,
    payoutMethod,
  });

  const footer = [
    <Button key="cancel" onClick={closeModal}>
      {t("payouts.cancel")}
    </Button>,
    <Button
      key="create"
      type="primary"
      htmlType="submit"
      form="createPayoutMethodForm"
      loading={createLoading || editLoading}
    >
      {isEdit ? t("payouts.save") : t("payouts.create")}
    </Button>,
  ];

  return (
    <Modal
      onCancel={closeModal}
      open={isVisible}
      title={t("payouts.create_modal_title", {
        action: isEdit ? t("payouts.edit") : t("payouts.create"),
      })}
      footer={footer}
      destroyOnHidden={true}
      width={500}
    >
      <CreateOrEditPayoutMethodForm
        onSubmit={createPayoutMethodHandler}
        isEdit={isEdit}
        payoutMethod={payoutMethod}
        asset={asset}
        setAsset={setAsset}
        network={network}
        setNetwork={setNetwork}
        source={source}
      />
    </Modal>
  );
};

export default CreateOrEditPayoutMethodModal;
